import { render, staticRenderFns } from "./BookingComment.vue?vue&type=template&id=6456df46&scoped=true"
import script from "./BookingComment.vue?vue&type=script&lang=js"
export * from "./BookingComment.vue?vue&type=script&lang=js"
import style0 from "./BookingComment.vue?vue&type=style&index=0&id=6456df46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6456df46",
  null
  
)

export default component.exports